<template>
  <Form
    ref="editTemplateForm"
    :edit-mode="true"
    @updated="updated"></Form>
</template>

<script>
import Form from "@views/admin/emails/Templates/Form";

export default {
  name: "EditTemplate",
  components: {Form},
  props: ["templateId"],
  async mounted() {
    this.startLoading();
    const {data} = await axios.get(`/api/app-http-services/services/notifications/email/templates/${this.templateId}`)
    this.$refs.editTemplateForm.template = data;
    this.$refs.editTemplateForm.template.moldId = data.mold_id;
    this.$refs.editTemplateForm.form = data.content;
    this.stopLoading();
  },
  methods: {
    async updated() {
      this.$emit("updated");
    }
  }
}
</script>
